import { ArrowDown, ArrowUpRight } from 'lucide-react';
import { HeroPicture } from '@/components/landing/hero-picture';
import { Hero3D } from '@/components/landing/hero-3d/Hero3D';
import { CredentialLine } from '@/components/landing/credential-line';
import { PILLARS } from '@/components/landing/inference-layers';
import { CREDENTIALS } from '@/content/credentials';
import { premizeHref } from '@/content/site';

/**
 * The hero: one sentence at full scale, one button, the proof as one line of
 * statements, and the picture rising under them with its own light.
 *
 * No entrance animation and no clock. The prerendered HTML paints before React
 * mounts and `createRoot` then re-mounts it, so a time-based entrance would
 * play twice and hold the CTA back. The only motion here is scroll-driven
 * (index.css): the stack settles as it scrolls into view. It is not a `Plate`,
 * so nothing in it ever starts at opacity 0.
 */
export function HeroSection() {
  return (
    <section id="top" aria-labelledby="hero-title" className="home-hero">
      <div className="home-hero-inner">
        <div className="hero-copy">
          <ul className="hero-kicker" aria-label="Three ways to put AI to work">
            {PILLARS.map((p) => (
              <li key={p.id}>
                <a href={`#${p.id}`} className="hero-pill">
                  {p.name}
                </a>
              </li>
            ))}
          </ul>

          <h1 id="hero-title" className="hero-h1">
            Private AI that works where you are.
          </h1>

          <p className="hero-sub">
            AI that runs in your office, uses the cloud only when you choose, and works inside machines and
            robots. Built on Qwen models and NVIDIA computers.
          </p>

          <div className="hero-ctas">
            <a href={premizeHref('hero')} target="_blank" rel="noopener noreferrer" className="btn-primary">
              Explore PreMize <ArrowUpRight className="h-4 w-4" />
            </a>
            <a href="#how" className="link-quiet justify-center">
              How it works <ArrowDown className="h-4 w-4" />
            </a>
          </div>

          <ul className="hero-proof" aria-label="Credentials">
            {CREDENTIALS.map((c) => (
              <li key={c.id}>
                <CredentialLine c={c} form="short" />
              </li>
            ))}
          </ul>
        </div>

        <div className="home-hero-figure">
          <div className="hero-light" aria-hidden />
          <Hero3D>
            <HeroPicture />
          </Hero3D>
        </div>
      </div>
    </section>
  );
}
